import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { InlineSVGConfig } from 'ng-inline-svg-2';
import { provideQuillConfig } from 'ngx-quill';
import { provideToastr } from 'ngx-toastr';
import { InterceptorService } from './core/interceptors/intercept';
import { langRoutes } from './app.routes';
import { I18nDetectorService } from './core/services/i18n.detector.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(langRoutes, withViewTransitions()),
    provideClientHydration(withEventReplay()),

    // provide  ('ngsw-worker.js', {
    //   enabled: environment.production,
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),

    importProvidersFrom(LoadingBarRouterModule),
    // CookieService,

    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [I18nDetectorService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },

    {
      provide: InlineSVGConfig,
      useValue: {
        baseUrl: '/assets/media/svg/',
      },
    },

    provideToastr({
      progressBar: true,
      positionClass: 'toast-bottom-left',
      timeOut: 1000 * 6,
      easing: 'ease-in',
    }), // Toastr providers

    provideQuillConfig({
      theme: 'snow',

      modules: {
        clipboard: true,

        imageResize: {
          displaySize: true,
        },
        resize: {
          locale: {
            center: 'center',
          },
        },

        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          //  [{ header: 1 }, { header: 2 }], // custom button values
          [{ size: ['small', false, 'large'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          //  [{ 'font': [] }],
          [{ align: [] }],
          [{ direction: 'rtl' }], // text direction
          ['image'],
          ['blockquote', 'code-block'],
          ['clean'], // remove formatting button
        ],

        table: false,
        'table-better': {
          language: 'en_US',
          menus: [
            'column',
            'row',
            'merge',
            'table',
            'cell',
            'wrap',
            'copy',
            'delete',
          ],
          toolbarTable: true,
        },
      },
    }),
  ],
};
export function initApp(i18nService: I18nDetectorService) {
  return () => i18nService.setLanguage();
}